const cguCgvContent = `UNISPORTDUHAUTNKAM.COM
Mentions légales – CGU – CGV – Politique de confidentialité

1. MENTIONS LÉGALES
Site internet : https://unisportduhautnkam.com
Propriétaire & éditeur : Unisport du Haut-Nkam (Club sportif officiel)
Adresse : Bafang, Région de l’Ouest, Cameroun
Email : contact@unisportduhautnkam.com
Responsable de publication : Le Président d’Unisport du Haut-Nkam
Hébergeur du site : OVH
Le présent site est soumis à la législation camerounaise.

2. CONDITIONS GÉNÉRALES D’UTILISATION (CGU)
2.1. Champ d’application
Les présentes CGU régissent l’accès et l’utilisation du site unisportduhautnkam.com, incluant la boutique en ligne, les formulaires de membres et de sponsoring, conformément à la loi camerounaise sur le commerce électronique.
L’utilisateur reconnaît avoir pris connaissance et accepter les CGU.
2.2. Accès au site
Le site est accessible gratuitement à tout utilisateur disposant d’une connexion Internet.
Unisport du Haut-Nkam peut suspendre ou interrompre l’accès au site pour maintenance, mise à jour ou raison technique.
2.3. Services proposés
Le site permet :
	•	la consultation des actualités du club ;
	•	l’achat de produits dérivés ;
	•	l’adhésion en tant que membre ;
	•	la demande de sponsoring ;
	•	l’accès aux informations sur les matchs et événements.
2.4. Compte utilisateur
La création d’un compte peut être nécessaire pour certaines fonctionnalités.
L’utilisateur garantit l’exactitude des informations fournies.
Il est entièrement responsable de la confidentialité de son identifiant et mot de passe.
Unisport du Haut-Nkam peut suspendre ou supprimer un compte en cas de fraude, tentative d’intrusion ou non-respect des CGU.
2.5. Propriété intellectuelle
Tous les contenus (logos, photos, vidéos, textes, graphismes) sont protégés par les lois camerounaises sur la propriété intellectuelle.
Toute reproduction non autorisée est strictement interdite.
2.6. Responsabilité
Unisport du Haut-Nkam ne garantit pas l'absence d’erreurs ou d’interruptions.
Le club décline toute responsabilité en cas :
	•	d’erreurs de contenu,
	•	d’indisponibilité du site,
	•	de dommages causés par un virus ou tout incident numérique,
	•	d’utilisation frauduleuse des données d’un utilisateur.
2.7. Liens externes
Les liens vers des sites tiers ne relèvent pas de la responsabilité d’Unisport du Haut-Nkam.
2.8. Modification des CGU
Les CGU peuvent être modifiées à tout moment. La version applicable est celle en ligne.

3. CONDITIONS GÉNÉRALES DE VENTE (CGV)
3.1. Produits
Les produits présentés sur le site correspondent à des articles officiels du club.
Les descriptions sont fournies à titre indicatif.
3.2. Prix
Les prix sont indiqués en francs CFA (XAF) ou en euros selon paramétrage.
Ils peuvent être modifiés à tout moment, mais le prix applicable est celui au moment de la commande.
3.3. Commande
Toute commande vaut acceptation des présentes CGV.
Unisport du Haut-Nkam se réserve le droit de refuser une commande en cas de suspicion de fraude ou d’erreur.
3.4. Paiement
Les paiements s’effectuent via :
	•	Mobile Money (MTN, Orange)
	•	Carte bancaire
	•	Autres moyens électroniques autorisés
	La commande n’est validée qu’après confirmation du paiement.
3.5. Livraison
Les livraisons sont assurées au Cameroun et à l’international.
Les délais varient selon la destination.
Un retard lié au transporteur ne constitue pas un motif d’indemnisation automatique.
3.5.1. Limitation géographique
Les expéditions de marchandises sont assurées uniquement dans les pays de l’Union européenne. Toute personne résidant en dehors de l’UE et souhaitant commander doit contacter le +33 768 739 598 avant de passer la commande afin d’étudier une solution spécifique.
3.6. Droit de rétractation / retours
Conformément à la loi camerounaise sur la protection du consommateur :
	•	les articles  ne sont ni repris, ni échangés.
3.7. Service client
Contact : contact@unisportduhautnkam.com

4. POLITIQUE DE CONFIDENTIALITÉ
(Conforme à la loi n°2010/012 sur la cybersécurité et à la loi n°2010/013 sur le commerce électronique)
4.1. Données collectées
Unisport du Haut-Nkam collecte les données suivantes :
	•	nom, prénom, adresse, téléphone, email ;
	•	données liées aux commandes ;
	•	informations de connexion (cookies, adresse IP).
4.2. Finalité
Les données sont collectées pour :
	•	la gestion des commandes ;
	•	la gestion des comptes ;
	•	l’envoi d’informations officielles ;
	•	la sécurité du site ;
	•	les statistiques internes.
4.3. Confidentialité et sécurité
Les données sont stockées conformément aux exigences de la loi camerounaise sur la cybersécurité.
Aucune donnée n’est vendue ni cédée à des tiers.
4.4. Partage des données
Les données peuvent être partagées uniquement avec :
	•	les prestataires de paiement,
	•	les prestataires de livraison,
	•	les prestataires techniques nécessaires au fonctionnement du site.
4.5. Durée de conservation
Les données sont conservées pour la durée nécessaire à la gestion de la relation client, puis archivées dans la limite autorisée par la loi camerounaise.
4.6. Droits des utilisateurs
Tout utilisateur dispose :
	•	d’un droit d’accès,
	•	d’un droit de rectification,
	•	d’un droit d’opposition,
	•	d’un droit à la suppression dans les limites prévues par la loi.
Toute demande doit être adressée à :
📧 contact@unisportduhautnkam.com
4.7. Cookies
Le site utilise des cookies techniques et analytiques.
L’utilisateur peut les désactiver depuis son navigateur.

5. CONTACT
Pour toute question concernant :
	•	les CGU,
	•	les CGV,
	•	la confidentialité,
	•	les données personnelles,
Écrivez à : contact@unisportduhautnkam.com`;

export default cguCgvContent;
